import { all, fork } from "redux-saga/effects";

import { reportingScalarModule } from "@multiweb/reactComponents";
import { coreModules } from "@multiweb/reactCore";
import { customizationModule } from "@multiweb/reactCustomization";
import { forkIfExists } from "@multiweb/reactUtils";
import { ApplicationModule, SagaWithReturnType } from "@multiweb/types/react";
import { aggregationRowModule } from "../aggregationRow";
import { linkButtonModule } from "../components/LinkButton";
import { framesModule } from "../frames";
import { menuModule } from "../menu";
import { workflowEditorModule } from "../workflowEditor";

/**
 * Vrací hlavní ságu aplikace. Spouští ságy core modulů, jednotlivé business modulů a custom modulů.
 */
export const getRootSaga = (): SagaWithReturnType => (
    function* rootSaga() {
        yield all(coreSagas.map((coreSaga) => fork(coreSaga)));
        yield fork(forkIfExists, framesModule.saga);
        yield fork(forkIfExists, menuModule.saga);
        yield fork(forkIfExists, aggregationRowModule.saga);
        yield fork(forkIfExists, workflowEditorModule.saga);
        yield fork(forkIfExists, customizationModule.getSaga());
        yield fork(forkIfExists, reportingScalarModule.saga);
        yield fork(forkIfExists, linkButtonModule.saga);
    }
);

/**
 * Hlavní sága aplikace. Spouští ságy core modulů a business modulů.
 */
export const coreSagas: Array<SagaWithReturnType> = coreModules
    .map((module: ApplicationModule<string>) => module.saga)
    .filter((saga) => saga) as SagaWithReturnType[];
